module.exports = __webpack_public_path__ + "static/media/GeorgiaPro-CondRegular.23e6cf33.ttf";